import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from './../../environments/environment';
import { LastPrestationsComponent } from '../last-prestations/last-prestations.component'
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

	@ViewChild('prestations',  {static: false}) prestations;

  test: string;
  constructor() { }

  ngOnInit() {
  	this.test = environment.apiRul;
  }
  addPrestation() {
  	this.prestations.addPrestation();
  }
}
